import { Formik, Form } from "formik";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

import { Icon } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { uploadSKU } from "services/data.internal.service";

import MDTypography from "components/MDTypography";
import { useState } from "react";
import { useCustomerValue } from "providers/CustomerContext";
import { InboundLayout, InboundHeaderCard } from "ui-components/Layout";
import { StripedDataGrid } from "ui-components/data-grids/StripedCheckboxDataGrid";
import { Error_, LoadingDialog } from "ui-components/Alert";
import { CSVLink } from "react-csv";
import dayjs from "dayjs";
import { ExportDialog } from "ui-components/Alert";
import useCsvDownloadHook from "hooks/useCsvDownloadHook";
import { InfoAlert } from "ui-components/Alert";

function UploadSKU() {
  const { customerCode } = useCustomerValue();
  const [alert, setAlert] = useState(null);
  const [uploadResps, setUploadResps] = useState([]);
  const uploadSKUMutation = useMutation(uploadSKU, {});
  const uploadStatus = uploadSKUMutation.status === "loading";
  const { downloadCsv, isDownloading } = useCsvDownloadHook();

  const handleSubmit = (values, actions) => {
    let formData = new FormData();
    formData.append("files", values.files[0], values.files[0].name);
    formData.append("customerCode", customerCode);

    uploadSKUMutation.mutate(formData, {
      onSuccess: (data) => {
        document.getElementById("files").value = null;
        actions.resetForm();
        setUploadResps(data.data.data);
      },
      onError: (data) => {
        setAlert(<Error_ data={data} onChange={setAlert} />);
      },
    });
    actions.setSubmitting(false);
  };

  const handleDownload = () => {
    window.open("/api/template/gettemplate?type=sku");
  };

  return (
    <InboundLayout lg={12}>
      {alert}
      {isDownloading && <ExportDialog />}
      {uploadStatus && <LoadingDialog />}
      <InboundHeaderCard>
      <InfoAlert content="SKU Template last updated on 17/7/2025"/>
        <MDBox>
          <MDBox pb={1}>
            <MDTypography color="info" variant="h3">
              Upload SKU
            </MDTypography>
            <MDTypography color="dark" variant="h3">
              Selected Customer: {customerCode}
            </MDTypography>
          </MDBox>
          <MDButton variant="gradient" color="info" onClick={handleDownload}>
            Download Template
          </MDButton>

          <Formik initialValues={{ files: [] }} onSubmit={handleSubmit}>
            {({ values, setFieldValue }) => (
              <Form>
                <MDBox mt={2}>
                  <input
                    type="file"
                    name="files"
                    id="files"
                    onChange={(e) => {
                      setUploadResps([]);
                      setFieldValue("files", e.target.files);
                    }}
                  />
                </MDBox>
                <MDBox mt={2} display="flex" justifyContent="center">
                  <MDButton
                    type="submit"
                    variant="gradient"
                    color="info"
                    disabled={!values.files.length > 0 || uploadStatus}
                  >
                    {uploadStatus ? "Uploading" : "Upload"}
                  </MDButton>
                </MDBox>
              </Form>
            )}
          </Formik>
        </MDBox>
      </InboundHeaderCard>

      {uploadResps.length > 0 && (
        <InboundHeaderCard>
          <MDTypography sx={{ marginBottom: ".5rem" }} color="info" variant="h4">
            Upload Response{" "}
            {/* <MDButton type="submit" variant="gradient" color="info">
              <Icon>download</Icon>&nbsp;
              <CSVLink
                style={{ color: "white" }}
                headers={[
                  {
                    label: "SKU Code",
                    key: "skuCode",
                  },
                  {
                    label: "Message",
                    key: "message",
                  },
                ]}
                filename={"upload_sku_" + dayjs(new Date()).format("DD-MM-YYYY")}
                data={uploadResps.filter((x) => !x.success)}
              >
                Export
              </CSVLink>
            </MDButton> */}
            <MDButton
              type="submit" variant="gradient" color="info"
              onClick={() => {
                const filename = `${customerCode}_${dayjs(new Date()).format("YYYYMMDD-HHmm")}_UploadSKU`;
                const headers = [
                  {
                    label: "SKU Code",
                    key: "skuCode",
                  },
                  {
                    label: "Message",
                    key: "message",
                  },
                ]
                downloadCsv(filename, uploadResps.filter((x) => !x.success), headers)
              }}
            >
              <Icon>download</Icon>&nbsp;
              export
            </MDButton>
          </MDTypography>
          <StripedDataGrid
            columns={[
              {
                headerName: "Status",
                field: "success",
                align: "center",
                renderCell: (cell) =>
                  cell.row.success ? (
                    <StatusIcon color="success" icon="done" />
                  ) : (
                    <StatusIcon color="error" icon="close" />
                  ),
              },
              { headerName: "SKU Code", field: "skuCode", width: 200 },
              {
                headerName: "Message",
                field: "message",
                flex: 1,
                wordWrapEnabled: true,
                renderCell: (cell) => (
                  <div>
                    {cell.row.message.map((c, i) => (
                      <p key={i}>{c}</p>
                    ))}
                  </div>
                ),
              },
            ]}
            rows={uploadResps}
            getRowHeight={(cell) => {
              if (cell.model.message.length > 2) {
                return "auto";
              } else {
                return 50;
              }
            }}
          />
        </InboundHeaderCard>
      )}
    </InboundLayout>
  );
}

const StatusIcon = ({ color, icon }) => (
  <MDButton color={color} variant="outlined" size="small" iconOnly circular>
    <Icon sx={{ fontWeight: "bold" }}>{icon}</Icon>
  </MDButton>
);

export default UploadSKU;
